import { render, staticRenderFns } from "./ProductHighlight.vue?vue&type=template&id=00475f44&scoped=true&"
import script from "./ProductHighlight.vue?vue&type=script&lang=js&"
export * from "./ProductHighlight.vue?vue&type=script&lang=js&"
import style0 from "./ProductHighlight.vue?vue&type=style&index=0&id=00475f44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00475f44",
  null
  
)

export default component.exports